import { render, staticRenderFns } from "./BpjsKetenagakerjaanDetail.vue?vue&type=template&id=6faf002e&"
import script from "./BpjsKetenagakerjaanDetail.vue?vue&type=script&lang=js&"
export * from "./BpjsKetenagakerjaanDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports